import { render, staticRenderFns } from "./ModListUserEditComp.vue?vue&type=template&id=023e377a&scoped=true&"
import script from "./ModListUserEditComp.vue?vue&type=script&lang=ts&"
export * from "./ModListUserEditComp.vue?vue&type=script&lang=ts&"
import style0 from "./ModListUserEditComp.vue?vue&type=style&index=0&id=023e377a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023e377a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
